import 'whatwg-fetch';

import {
    createElementHTML
} from "./utils";

const container_resultado = document.querySelector('.resultado-certificado');
const page_certificado = document.querySelector('.page-certificado');
let form_certificado = null;

const handlerClickResultado = (e) => {
    const elemTarget = e.target.closest('.btn-voltar-solicitacao');

    if (elemTarget) {
        e.preventDefault();

        form_certificado.classList.remove('d-none');
        container_resultado.classList.add('d-none');
        container_resultado.addEventListener('click', handlerClickResultado, false);
        container_resultado.innerHTML = '';
    }

};

const resultRequest = (retorno = {}) => {
    let msg = 'Ops! ocorreu um erro ao fazer a solicitação. Por favor tente novamente.';

    const h1 = createElementHTML('h1');
    const img = createElementHTML('img', {
        src: BASEURL + 'img/img-erro.png',
        class: 'img-fluid d-block mx-auto mb-3'
    });

    const div_alert = createElementHTML('div', {
        class: 'msg-resultado mb-4'
    }, '');

    if (retorno.mensagem)
        msg = retorno.mensagem;

    if (retorno.status) {
        page_certificado.classList.add('container-sucesso');

        const svg =
            '<svg id="successAnimation" class="animated" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">' +
            '  <path id="successAnimationResult" fill="#D8D8D8" d="M35,60 C21.1928813,60 10,48.8071187 10,35 C10,21.1928813 21.1928813,10 35,10 C48.8071187,10 60,21.1928813 60,35 C60,48.8071187 48.8071187,60 35,60 Z M23.6332378,33.2260427 L22.3667622,34.7739573 L34.1433655,44.40936 L47.776114,27.6305926 L46.223886,26.3694074 L33.8566345,41.59064 L23.6332378,33.2260427 Z"/>' +
            '  <circle id="successAnimationCircle" cx="35" cy="35" r="24" stroke="#979797" stroke-width="2" stroke-linecap="round" fill="transparent"/>' +
            '  <polyline id="successAnimationCheck" stroke="#979797" stroke-width="2" points="23 34 34 43 47 27" fill="transparent"/>' +
            '</svg>';

        div_alert.innerHTML = msg;

        h1.innerHTML = 'Solicitação realizada!';

        page_certificado.innerHTML = svg;
        page_certificado.appendChild(h1);
        page_certificado.appendChild(div_alert);

    } else {

        div_alert.classList.add('text-danger');
        div_alert.innerHTML = msg;

        container_resultado.innerHTML = '';
        container_resultado.appendChild(img);
        container_resultado.appendChild(div_alert);
        container_resultado.appendChild(createElementHTML('a', {
            href: 'javascript:void(0)',
            class: 'btn d-block text-center text-dark bg-light border w-100 btn-voltar-solicitacao'
        }, 'Voltar'));

        container_resultado.addEventListener('click', handlerClickResultado, false);

    }

};

export default (form) => {

    form_certificado = form;
    form_certificado.classList.add('d-none');
    container_resultado.classList.remove('d-none');
    container_resultado.innerHTML = '<div class="load">' +
        '<div class="lds-default">' +
        '<div></div>' +
        '<div></div>' +
        '<div></div>' +
        '<div></div>' +
        '<div></div>' +
        '<div></div>' +
        '<div></div>' +
        '<div></div>' +
        '<div></div>' +
        '<div></div>' +
        '<div></div>' +
        '<div></div>' +
        '</div>' +
        '<p>Enviando solicitação, aguarde...</p>' +
        '</div>';

    fetch(BASEURL + 'ajax-solicitacao', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: $(form).serialize()
        })
        .then((response) => {

            if (response.ok) {
                return response.json();
            } else {
                resultRequest();
            }

        })
        .then((retorno) => {
            resultRequest(retorno);
        })
        .catch(() => {
            resultRequest({});
        })

    return false;
};